export class ResendForm {
    public screenname: string = '';
    public password: string = '';
    public email: string = '';

    constructor() {

    }
}


// WEBPACK FOOTER //
// ./src/models/resend-form.ts